/* eslint-disable */
import axios, { AxiosResponse } from 'axios';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './styles/style.module.scss';
import Plans from './layouts/plans';
import Footer from '../../layouts/footer';
import Button from '../../components/ui/button/Button';
import Separator from './layouts/separator';
import tashaImg from '../../assets/images/tashaWithoutFace.png';
import sophiaImg from '../../assets/images/sophiaWithoutFace.png';
import isabellaImg from '../../assets/images/IsabellaWithotFace.png';
import jamesImg from '../../assets/images/james.webp';
import danielImg from '../../assets/images/daniel.webp';
import michaelImg from '../../assets/images/michael.webp';
import { useStore } from '../../store/store';
import { ReactComponent as StarSvg } from '../../assets/images/star.svg';
import { ReactComponent as HandSvg } from './styles/hand.svg';
import { ReactComponent as ActiveSVG } from '../../assets/images/check.svg';
import { ReactComponent as LightningSvg } from '../../assets/images/lightning.svg';
import { debounce } from 'lodash';
import { selectProducts } from 'core/store/billing/selectors';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import { t } from '@web-solutions/module-localization';
import getLocale from '../../../localization/get-locale';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
import GoalGraphPaywall from './layouts/goalGraph';
import { getEnvUrl } from 'src/onboarding/helpers/getEnvUrl';
import EatLoseContainer from './layouts/eatLoseContainer';
import { Allergies, UserPayload, UserResponse } from 'src/onboarding/types/api';
import HealthDashboardCard from './layouts/healthDashboardCard';
import { ReactComponent as TargetSvg } from '../../assets/images/target.svg';
import { ReactComponent as ClockSvg } from '../../assets/images/clockSvg.svg';
import { ReactComponent as CameraSvg } from '../../assets/images/camera.svg';
import { ReactComponent as FaceSvg } from '../../assets/images/face.svg';
import { ReactComponent as MenuSvg } from '../../assets/images/menu.svg';
import { ReactComponent as HomeSvg } from '../../assets/images/home.svg';
import BeforeAfterCard from './layouts/beforeAfterCard';
import MealPlanContainer from './layouts/mealPlanContainer';
import { EmailPopup } from 'src/onboarding/components/ui/email-popup/EmailPopup';
import { GiftPopup } from 'src/onboarding/components/ui/gift-popup/GiftPopup';
import { applyFoodzeeAuthTokens } from 'src/onboarding/helpers/applyFoodzeeAuthTokens';
declare const gtag: Function;

const EMAIL_POPUP_KEY = 'email_popup_shown';
const GIFT_POPUP_KEY = 'gift_popup_shown';

interface Customer {
  img: string;
  name: string;
  descriptions: string;
  weightLeft: number;
  weightRight: number;
}

interface PlansRef {
  onPayment: () => void;
}

function addDaysToDate(days: string): string {
  const daysNumber = parseInt(days, 10);
  if (isNaN(daysNumber)) {
    return '';
  }

  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + daysNumber);

  const formatter = new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
  const formattedDate = formatter.format(currentDate);
  console.log('formattedDate ', formattedDate);
  return formattedDate;
}

const PersnalPlan = () => {
  const dispatch = useDispatch();
  const locale = getLocale();
  const childRef = useRef<PlansRef>(null);
  const state = useStore((state) => state);
  const {
    setPage,
    email,
    born: age,
    gender,
    preferences: dietary,
    height,
    weight,
    idealWeight,
    when,
    setUserId,
    savedOnboarding,
    setSavedOnboarding,
    name: userName,
    generatedPhotoUrl,
    photoError,
    photoProcessingUuid,
    existTimeoutId,
    bodyImageUrl,
    bodyScanError,
    bmi,
    bodyImageFile,
    bodyType,
  } = state;

  const productsObj = useSelector(selectProducts);
  const {
    specialOffer,
    showGeneratedPhotoOnPaywall,
    products,
    routeGroups: flow,
    showBeforeAfterOnPaywall,
    showPlanDescription,
    showMealPlanPaywall,
    showEmailPopup,
    showGiftPopup,
    paymentSystem,
  } = useRemoteConfig();

  const [showDownSaleModalOnce, setShowDownSaleModalOnce] = useState(false);
  const [isEmailPopupOpen, setIsEmailPopupOpen] = useState(
    true && !sessionStorage.getItem(EMAIL_POPUP_KEY)
  );

  const [isGiftPopupOpen, setIsGiftPopupOpen] = useState(false);

  useEffect(() => {
    if (showEmailPopup && !sessionStorage.getItem(EMAIL_POPUP_KEY)) {
      setIsEmailPopupOpen(true);
    } else if (showGiftPopup && !sessionStorage.getItem(GIFT_POPUP_KEY)) {
      setIsGiftPopupOpen(true);
    }
  }, []);

  const handleEmailPopupClose = () => {
    setIsEmailPopupOpen(false);
    sessionStorage.setItem(EMAIL_POPUP_KEY, 'true');

    if (showEmailPopup) {
      setIsGiftPopupOpen(true);
    }
  };

  const handleGiftPopupClose = () => {
    setIsGiftPopupOpen(false);
    sessionStorage.setItem(GIFT_POPUP_KEY, 'true');
  };

  const { apiBaseUrl } = getEnvUrl();

  useEffect(() => {
    gtag('event', 'conversion', {
      send_to: 'AW-17149973324/gwbSCMu_yP0aEMym3_E_',
      value: 1.5,
      currency: 'USD',
    });
  }, []);

  useEffect(() => {
    return () => {
      clearTimeout(existTimeoutId);
    };
  }, [existTimeoutId]);

  const services = [
    {
      icon: <TargetSvg />,
      title: t('onboarding.highlights.getPlan.title'),
      description: t('onboarding.highlights.getPlan.description'),
    },
    {
      icon: <ClockSvg />,
      title: t('onboarding.highlights.stayFlexible.title'),
      description: t('onboarding.highlights.stayFlexible.description'),
    },
    {
      icon: <CameraSvg />,
      title: t('onboarding.highlights.trackMeals.title'),
      description: t('onboarding.highlights.trackMeals.description'),
    },
    {
      icon: <FaceSvg />,
      title: t('onboarding.highlights.understandHabits.title'),
      description: t('onboarding.highlights.understandHabits.description'),
    },
    {
      icon: <MenuSvg />,
      title: t('onboarding.highlights.makeChoices.title'),
      description: t('onboarding.highlights.makeChoices.description'),
    },
    {
      icon: <HomeSvg />,
      title: t('onboarding.highlights.cookSmarter.title'),
      description: t('onboarding.highlights.cookSmarter.description'),
    },
  ];

  const foodzePlanitems: string[] = [
    t('onboarding.personalPlan.eatLose.enjoyFood'),
    t('onboarding.personalPlan.eatLose.keepWeightOff'),
    t('onboarding.personalPlan.eatLose.noDiet'),
    t('onboarding.personalPlan.eatLose.healthyHabits'),
    t('onboarding.personalPlan.eatLose.eatWell'),
  ];

  const customers: Customer[] = [
    {
      img: tashaImg,
      name: t('onboarding.personalPlan.customers.1.name'),
      descriptions: t('onboarding.personalPlan.customers.1.descriptions'),
      weightLeft: 75,
      weightRight: 60,
    },
    {
      img: sophiaImg,
      name: t('onboarding.personalPlan.customers.2.name'),
      descriptions: t('onboarding.personalPlan.customers.2.descriptions'),
      weightLeft: 80,
      weightRight: 60,
    },
    {
      img: isabellaImg,
      name: t('onboarding.personalPlan.customers.3.name'),
      descriptions: t('onboarding.personalPlan.customers.3.descriptions'),
      weightLeft: 90,
      weightRight: 55,
    },
  ];

  const customersMen: Customer[] = [
    {
      img: jamesImg,
      name: t('onboarding.personalPlan.customersMen.1.name'),
      descriptions: t('onboarding.personalPlan.customersMen.1.description'),
      weightLeft: 128,
      weightRight: 96,
    },
    {
      img: danielImg,
      name: t('onboarding.personalPlan.customersMen.2.name'),
      descriptions: t('onboarding.personalPlan.customersMen.2.description'),
      weightLeft: 107,
      weightRight: 85,
    },
    {
      img: michaelImg,
      name: t('onboarding.personalPlan.customersMen.3.name'),
      descriptions: t('onboarding.personalPlan.customersMen.3.description'),
      weightLeft: 124,
      weightRight: 97,
    },
  ];

  console.log('products ', products);
  const productDescription = showDownSaleModalOnce
    ? {
        name: specialOffer.products[0]?.name,
        plan_end_days: addDaysToDate(specialOffer.products[0]?.plan_end_days),
        subTitle: specialOffer.products[0]?.subTitle[locale],
        title: specialOffer.products[0]?.title[locale],
        price: specialOffer.products[0]?.priceStartTrial.price,
      }
    : {
        name: products[0]?.name,
        plan_end_days: addDaysToDate(products[0]?.priceStartTrial.plan_end_days),
        subTitle: products[0]?.subTitle[locale],
        title: products[0]?.title[locale],
        price: products[0]?.priceStartTrial.price[locale],
      };
  const { name, plan_end_days, subTitle, title, price } = productDescription;

  const payment = () => {
    childRef.current.onPayment();
  };

  const setOnboardingData = useCallback(
    debounce(async () => {
      try {
        const payload: UserPayload = {
          email,
        };

        const response: AxiosResponse<UserResponse> = await axios.post(
          `${apiBaseUrl}/v2/user`,
          payload
        );

        if (response.status === 201) {
          const filteredState = Object.fromEntries(
            Object.entries({ ...state }).filter(
              ([key, value]) => typeof value !== 'function' && key !== 'faceScanBase64'
            )
          );

          setUserId(response.data.uid);
          applyFoodzeeAuthTokens(response.data, dispatch, { reinitBilling: true, paymentSystem });

          await axios.post(`${apiBaseUrl}/onboarding`, {
            json: JSON.stringify(filteredState),
            user_id: response.data.uid,
          });
        }

        setSavedOnboarding(true);
      } catch (error) {
        // need change
        setSavedOnboarding(true);
        console.error('Error:', error);
      }
    }, 500),
    [email, gender, height, weight, state]
  );

  useEffect(() => {
    if (showEmailPopup && isEmailPopupOpen) {
      return;
    }

    if (!savedOnboarding) {
      setOnboardingData();
    }
    return () => {
      setOnboardingData.cancel();
    };
  }, [setOnboardingData, savedOnboarding, showEmailPopup, isEmailPopupOpen]);

  return (
    <>
      <div className={styles.page}>
        <div className={styles.container}>
          <Title tag='h4' className={styles.title}>
            {t('onboarding.personalPlan.title.1')}{' '}
            <span>{t('onboarding.personalPlan.title.2')}</span>{' '}
            {t('onboarding.personalPlan.title.3')}
          </Title>
          {showBeforeAfterOnPaywall && flow.flat().includes('body-type') && bodyType !== 'Slim' ? (
            <BeforeAfterCard />
          ) : (
            <GoalGraphPaywall />
          )}
          <div className={styles.bodyContainer}>
            {flow?.flat().includes('full-body-photo') &&
              !bodyScanError &&
              bodyImageUrl?.length > 0 && <HealthDashboardCard url={bodyImageFile} bmi={bmi} />}

            <Title tag='h4' className={styles.chooseTitle}>
              {t('onboarding.personalPlan.plan.choosePlan')}
            </Title>
            <Plans
              ref={childRef}
              showDownSaleModalOnce={showDownSaleModalOnce}
              setShowDownSaleModalOnce={setShowDownSaleModalOnce}
            />
            {/* <Button className={styles.startTrialBtn} title='Start Trial and Cantinue'/> */}
            <span className={styles.privacy}>
              {t('onboarding.personalPlan.plan.accept')}{' '}
              <a onClick={() => setPage('privacy-policy')}>
                {t('onboarding.personalPlan.plan.privacy')}
              </a>
              ,{' '}
              <a onClick={() => setPage('terms-of-use')}>
                {t('onboarding.personalPlan.plan.terms')}
              </a>
            </span>
            <Separator />
            {showPlanDescription && (
              <span className={styles.privacy}>
                {t('onboarding.personalPlan.plan.planExpires')} {plan_end_days}.{' '}
                {t('onboarding.personalPlan.plan.harged')} {subTitle}{' '}
                {t('onboarding.personalPlan.plan.for')} {title},{' '}
                {t('onboarding.personalPlan.plan.then')} {price}.{' '}
                {t('onboarding.personalPlan.plan.last')}
              </span>
            )}

            {showBeforeAfterOnPaywall &&
              flow.flat().includes('body-type') &&
              bodyType !== 'Slim' && (
                <div style={{ paddingTop: '20px', width: '100%' }}>
                  <GoalGraphPaywall />
                </div>
              )}

            {showMealPlanPaywall && <MealPlanContainer />}

            {/* eat what you love block */}
            <Title tag='h4' className={styles.eatTitle}>
              {t('onboarding.personalPlan.eatLose.eat')}{' '}
              <span>{t('onboarding.personalPlan.eatLose.lose')}</span>
            </Title>
            {showGeneratedPhotoOnPaywall ? (
              generatedPhotoUrl && photoProcessingUuid && !photoError ? (
                <div className={styles.plan}>
                  <div className={styles.planContent}>
                    <div className={styles.planTitle}>
                      <Text size='m' medium>
                        {t('onboarding.personalPlan.eatLose.foodzeePlan')}{' '}
                      </Text>
                      <LightningSvg />
                    </div>
                    <div className={styles.planItems}>
                      {foodzePlanitems.map((item) => (
                        <div className={styles.planItem} key={item}>
                          <div style={{ width: 16 }}>
                            <ActiveSVG />
                          </div>
                          <Caption size='xs'>{item}</Caption>
                        </div>
                      ))}
                    </div>
                  </div>
                  <img src={generatedPhotoUrl} />
                </div>
              ) : (
                <EatLoseContainer />
              )
            ) : (
              <EatLoseContainer />
            )}

            <Button
              className={styles.startTrialBtn}
              title={t('onboarding.personalPlan.getMyPlan')}
              onClick={payment}
            />

            <Title tag='h4' className={styles.eatTitle}>
              {t('onboarding.highlights.title.start')}
              <span> {t('onboarding.highlights.title.end')}</span>
            </Title>

            <div className={styles.services}>
              {services.map((service, index) => (
                <div className={styles.service} key={index}>
                  <div style={{ width: 36 }}>{service.icon}</div>
                  <div className={styles.serviceText}>
                    <Text semibold>{service.title}</Text>
                    <span>{service.description}</span>
                  </div>
                </div>
              ))}
            </div>
            <Button
              className={styles.startTrialBtn}
              title={t('onboarding.personalPlan.getMyPlan')}
              onClick={payment}
            />

            <div className={styles.customers}>
              <Title tag='h4' className={styles.customerTitle}>
                {t('onboarding.personalPlan.customersReviews')}
              </Title>
              {(gender === 'Male' ? customersMen : customers).map(
                ({ img, name, descriptions, weightLeft, weightRight }, index) => (
                  <div className={styles.customer} key={index}>
                    <div className={styles.customerImgContainer}>
                      <img className={styles.customerImg} src={img} />
                      <span className={styles.weightLeft}>{weightLeft} kg</span>
                      <span className={styles.weightRight}>{weightRight} kg</span>
                    </div>

                    <div className={styles.customerTop}>
                      <span className={styles.customerName}>{name}</span>
                      <span className={styles.customerRating}>
                        {Array.from({ length: 5 }, (_, i) => (
                          <StarSvg key={i} />
                        ))}
                      </span>
                    </div>
                    <div className={styles.customerBody}>{descriptions}</div>
                  </div>
                )
              )}
              <div className={styles.moneyBack}>
                <HandSvg />
                <h2>{t('onboarding.personalPlan.moneyBack.title')}</h2>
                <span className={styles.firsBody}>
                  {t('onboarding.personalPlan.moneyBack.sub1')}
                </span>
                <span className={styles.secondBody}>
                  {t('onboarding.personalPlan.moneyBack.sub2')}
                </span>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>

      <Timer payment={payment} showDownSaleModalOnce={showDownSaleModalOnce} />
      {showEmailPopup && <EmailPopup isOpen={isEmailPopupOpen} onClose={handleEmailPopupClose} />}

      {showGiftPopup && <GiftPopup isOpen={isGiftPopupOpen} onClose={handleGiftPopupClose} />}
    </>
  );
};

export const Timer = ({ payment, showDownSaleModalOnce }) => {
  const [timeLeft, setTimeLeft] = useState(595);
  const [isTimerVisible, setIsTimerVisible] = useState(true);

  useEffect(() => {
    if (showDownSaleModalOnce) {
      setIsTimerVisible(false);
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timer);
          setIsTimerVisible(false);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [showDownSaleModalOnce]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  return (
    <>
      {isTimerVisible && !showDownSaleModalOnce && (
        <div className={styles.timer}>
          <span>{formatTime(timeLeft)}</span>
          <Button title={t('onboarding.personalPlan.getMyPlan')} onClick={payment} />
        </div>
      )}
    </>
  );
};

export default PersnalPlan;
